import h from 'react-hyperscript';
import md5 from 'md5';

const getGravatarByEmail = ({ email, size = 35, fallback = 'mm' } = {}) =>
  `https://www.gravatar.com/avatar/${email ? md5(email.trim().toLowerCase()) : '0000000'}?s=${size}&d=${fallback}`;

const getProfileThumbUrl = ({ email, first, firstName, last, lastName, picture, fallback: customFallback, size }) => {
  if (picture) {
    return picture;
  }

  let fallback = customFallback;
  const fName = first || firstName;
  const lName = last || lastName;

  if (fName && lName) {
    const [firstInitial, lastInitial] = [fName.substring(0, 1), lName.substring(0, 1)].map(initial =>
      initial.toLowerCase(),
    );

    fallback = encodeURIComponent(`https://cdn.auth0.com/avatars/${firstInitial}${lastInitial}.png`);
  } else if (fName && fName.length > 1) {
    const [firstInitial, lastInitial] = fName.toLowerCase().split('');

    fallback = encodeURIComponent(`https://cdn.auth0.com/avatars/${firstInitial}${lastInitial}.png`);
  } else if (lName && lName.length > 1) {
    const [firstInitial, lastInitial] = lName.toLowerCase().split('');

    fallback = encodeURIComponent(`https://cdn.auth0.com/avatars/${firstInitial}${lastInitial}.png`);
  }

  if (email) {
    return getGravatarByEmail({ email, size, fallback });
  }

  return getGravatarByEmail({ size, fallback });
};

export default ({ email, firstName, lastName, first, last, fallback, className, size } = {}) => {
  const displayText = firstName && lastName ? `${firstName} ${lastName}` : email || 'profile image';

  return h('img.img-avatar', {
    className,
    src: getProfileThumbUrl({ email, first, firstName, last, lastName, fallback, size }),
    alt: displayText,
    title: displayText,
  });
};



// WEBPACK FOOTER //
// ./src/components/Avatar/Avatar.js